import { render, staticRenderFns } from "./performance-brand-delivery.vue?vue&type=template&id=82b06438&scoped=true"
import script from "./performance-brand-delivery.vue?vue&type=script&lang=js"
export * from "./performance-brand-delivery.vue?vue&type=script&lang=js"
import style0 from "./performance-brand-delivery.vue?vue&type=style&index=0&id=82b06438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b06438",
  null
  
)

export default component.exports